import React from 'react'
import { IoIosArrowDropdown, IoIosArrowDropleft } from 'react-icons/io';

const ShowHideIcon = ({show, setShow}) => {
    const selectorToggle = () =>{
        setShow(!show)
    }
const icon = () => {
    const size = 25
    if(!show) return <IoIosArrowDropleft size={size}/>
    return <IoIosArrowDropdown size={size}/>
}
  return (
    <div>
      <div onClick={()=>selectorToggle()}>
      {icon()}
     </div>
    </div>
  )
}

export default ShowHideIcon
